import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useErrorManagerStore = defineStore('errorManager', () => {
  // State
  const error = ref(null)
  const gameCode = ref(null)
  const game = ref(null)
  const errorType = ref(null) // 'logout', 'deposit', 'unfinishedGame', 'freeGameSettle', 'freeGameGiveUp'
  const addCryptoBank = ref(false)

  // Getters
  const getError = computed(() => error.value)
  const getGameCode = computed(() => gameCode.value)
  const getGame = computed(() => game.value)
  const getErrorType = computed(() => errorType.value)
  const getAddCryptoBank = computed(() => addCryptoBank.value)
  const hasError = computed(() => error.value !== null)

  // Actions
  function setError(data) {
    error.value = data
  }

  function setGameCode(data) {
    gameCode.value = data
  }

  function setGame(data) {
    game.value = data
  }

  function setErrorType(data) {
    errorType.value = data
  }

  function setAddCryptoBank(data) {
    addCryptoBank.value = data
  }

  function clearError() {
    error.value = null
    errorType.value = null
    gameCode.value = null
    game.value = null
  }

  return {
    // State
    error,
    gameCode,
    game,
    errorType,
    addCryptoBank,

    // Getters
    getError,
    getGameCode,
    getGame,
    getErrorType,
    hasError,
    getAddCryptoBank,

    // Actions
    setError,
    setGameCode,
    setGame,
    setErrorType,
    clearError,
    setAddCryptoBank,
  }
})
